"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserSupport = (function () {
    function BrowserSupport() {
    }
    BrowserSupport.prototype.canSupportRel = function (rel) {
        var link = document.createElement('link');
        return !!(link.relList &&
            link.relList.supports &&
            link.relList.supports(rel));
    };
    return BrowserSupport;
}());
exports.default = BrowserSupport;
//# sourceMappingURL=browser-support.js.map